// ********* AtivarConta - ativarconta.jsx ********
// autor: W de Paula / MVinfo
// data: 23/7/24 | 12h39
// **************************************************





import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiaxios from '../../../../Services/apiaxios';
import handleApiError from '../../../../Services/apiErrorHandler';
import { encrypt, decrypt } from '../../../../Services/cryptoUtils';
import { AutoLogout } from '../../../../Services/autologout';
import Swal from 'sweetalert2';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import AgendexPrestador from '../../../../Assets/agendex/logoagendexprestador.png';

import "./pc_ativarconta.css";
import { apifetch } from '../../../../Services/apifecth';

function AtivarConta() {
    const tokenASW = localStorage.getItem("tokenasw");
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    var ano = new Date().getFullYear();

    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const navigate = useNavigate();
    const { nome, email, id_usuario, validationCode, from } = location.state || {}; // Get email from state passed during navigation
    const [cv, setCv] = useState(validationCode);
    // const [usunome, setUsunome] = useState(nome);
    // const [usuemail, setusuemail] = useState(email);

    const [codigo, setCodigo] = useState(); // código digitado pelo usuário
    const [ativa_conta, setAtiva_conta] = useState(); // 0=conta inativa / 1=conta ativada
  
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false); // loading na tela

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Após validar o email
    const atualizarUsuAtivaConta = (ativo) => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                decryptedUser.ativa_conta = ativo;
                const encryptedUpdatedUser = encrypt(decryptedUser);
                localStorage.setItem('tokenacw', encryptedUpdatedUser);
            } catch (error) {
                console.error('Erro ao atualizar usu_ativa_conta:', error);
            }
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSubmit();
        }
    };

    const handleBackClick = () => {
        // navigate(-1); // Navegar para a página anterior
        if (from) {
            navigate(from); // Redireciona para a página que chamou esta
        } else {
            navigate('/app/prestador/home'); // Redireciona para uma página padrão se "from" não estiver definido
        }
    };
    
    async function handleSubmit() {
        if (!codigo) {
            setMensagem('Digite o código de validação enviado no seu E-mail.');

            setTimeout(() => {
                setMensagem('');
            }, 7000);
            return;
        }

        if (codigo !== cv) {
                setMensagem('Código inválido. Digite novamente ou solicite um novo código.');

                setTimeout(() => {
                    setMensagem('');
            }, 7000);
            return;
        }
        ativarConta(nome, email, cv);
    }

    const ativarConta = async (nome, email, codigo) => {
    
        setLoading(true);
        try {
            const response = await apiaxios.post('/usuario/AtivaContaWeb', {
                nome: '',
                email,
                tipoApp: 1
            },
            {
                params: {
                    id_usuario,
                    token: tokenASW
                }
            });

            if (response.status === 200) {
                const data = response.data;
                if (data.retorno === 'OK') {
                    setAtiva_conta(1);
                    // Swal.fire('E-mail Validado', "Agora, você já pode realizar agendamentos!", 'info');
                    Swal.fire('E-mail Validado', "Agora, você já pode cadastrar sua empresa / negócio!", 'info').then(() => {
                        // Chame esta função após a validação do email ser bem-sucedida
                        atualizarUsuAtivaConta(1); // 1 indica que a conta está ativada
                       
                        if (from) {
                            navigate(from); // Redireciona para a página que chamou esta
                        } else {
                            navigate('/app/prestador/home'); // Redireciona para uma página padrão se "from" não estiver definido
                        }
                    });
                } else {
                    Swal.fire('Erro', data.retorno, 'error');
                }
            } else {
                Swal.fire('Erro', 'Falha ao carregar seus dados. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    function generateValidationCode() {
        return Math.floor(100000 + Math.random() * 900000).toString();
    }

    async function handleResendCode() {
        if (!email) {
            setMensagem('E-mail inválido. Clique no botão voltar pra tentar novamente!');
            setTimeout(() => {
                setMensagem('');
            }, 7000);
            return;
        }
        // const authString = btoa(`${BA_USERNAME}:${BA_PASSWORD}`);
        // const url = new URL(`${API_URL}/usuario/validaEmail`);
        const validationCode = generateValidationCode();
        // // console.log('handleResendCode email: ', usuemail, email);
        // url.search = new URLSearchParams({
        //     email: email,
        //     codigo: validationCode
        // }).toString();
        
        setLoading(true);

        // console.log('email / código recebido :' + email + ' / ' + validationCode);

        try {
            // const response = await fetch(url.toString(), {
            //     method: 'GET',
            //     headers: {
            //         'Content-Type': 'application/json',
            //         'Authorization': `Basic ${authString}`
            //     }
            // });

            // if (!response.ok) {
            //     const data = await response.json();
            //     throw new Error(data.retorno);
            // }

            // const data = await apifetch(`/usuario/validaEmailWeb?email=${email}&codigo=${validationCode}`, {
            //     method: 'GET'
            // });
            const response = await apiaxios.post('/usuario/validaEmailWeb', {
                nome: '',
                email,
                codigo: validationCode,

            },
            {
                params:{
                    id_usuario,
                    token: tokenASW
                }
            });

            setCv(validationCode);
            setLoading(false);
            setMensagem('Novo Código de Validação enviado para seu email.');
            setTimeout(() => {
                setMensagem('');
            }, 10000);

        } catch (error) {
            // Trate o erro
            setLoading(false);
            setMensagem(error.message);
        }
    }

    function handleCancel() {
        navigate('/app/prestador/home');
    }

    
    return (
        <section id="perfilativaconta">
            <div className="container login-container">
                <div className="row">
                    <div className="col-md-6 login-form-1">
                        <button className="btn btn-secondary back-button" onClick={handleBackClick}>
                            <Icon path={mdiArrowLeftCircle} size={1}/> {!isMobile && 'Voltar'}
                        </button>

                        <img className="login-prestador-img" src={AgendexPrestador} alt='Login Prestador'/>
                        <h3>Validar Email</h3>

                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                        )}
                        <div className={`row ${loading ? 'd-none' : ''}`}></div>

                        <form action="">
                        <div className="form-group mb-3">
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Digite o Código de Validação recebido(*)"
                                value={codigo}
                                onChange={(e) => setCodigo(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>
                        <div className="form-group mb-4">
                            <input
                                type="button"
                                className="btnSubmit"
                                value="Validar Email"
                                onClick={handleSubmit}
                            />
                            {mensagem.length > 0 && <div className="alert alert-danger mt-2" role="alert">{mensagem}</div>}
                        </div>
                        </form>
                        <p className='text-light'>
                            Não recebeu o código? 
                            <button onClick={handleResendCode} className="btn btn-link">Reenviar Código</button>
                        </p>
                        <button onClick={handleCancel} className="btn btn-secondary mt-2">Cancelar</button>
                    </div>
                </div>
                <p className="text-sm">(*) campo obrigatório.</p>
                <div className="textoRodape" >
                    <p > Desenvolvido por MVinfo Sistemas | by WMX Group 2021 - {ano}</p>
                </div>

            </div>
        </section>
    );
}

export default AtivarConta;
